var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { NavBar, NavBarList, cssSpacing, screenSmMax, } from '@spotify-internal/encore-web';
import styled, { useTheme } from 'styled-components';
import { trackCat } from '../constants';
import { isMastheadCategoryMenu, isMastheadGalleryMenu, isMastheadLink, isMastheadLinkList, isMastheadLinkListItem, } from '../../../utils/contentful';
import { trackingAttributes } from '../../../lib/buildTrackingAttributes';
import { isNotUndefined } from '../../../lib/isNotUndefined';
import { useActiveSubmenu, useActiveSubmenuContext, } from '../../ActiveSubmenu/ActiveSubmenuProvider';
import { S4XDropdown } from './S4XDropdown';
import { SubmenuTrigger } from '../FlyoutMenu/Trigger';
import { TextLink } from '../../LinkV2';
var StyledNavBar = styled(NavBar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), screenSmMax);
var StyledNavBarList = styled(NavBarList)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  gap: ", ";\n  line-height: 24px;\n  margin: 0;\n  overflow-x: visible;\n  padding: 0;\n  li {\n    display: flex;\n    align-items: center;\n  }\n"], ["\n  gap: ", ";\n  line-height: 24px;\n  margin: 0;\n  overflow-x: visible;\n  padding: 0;\n  li {\n    display: flex;\n    align-items: center;\n  }\n"])), cssSpacing('looser-2'));
var NavbarDropdown = function (_a) {
    var id = _a.id, props = __rest(_a, ["id"]);
    var _b = useActiveSubmenu(id), activeSubmenu = _b.activeSubmenu, claimActiveSubmenu = _b.claimActiveSubmenu, clearActiveSubmenu = _b.clearActiveSubmenu;
    return (React.createElement(S4XDropdown, __assign({ onOpen: claimActiveSubmenu, onClose: clearActiveSubmenu, opened: activeSubmenu ? activeSubmenu === id : false }, props)));
};
var buildPopoverLinkItems = function (linkListItem) {
    var link = linkListItem.fields.mastheadLink;
    return {
        trackingAttributes: trackingAttributes(trackCat, link.fields.trackingId),
        href: link.fields.href,
        linkText: link.fields.title,
        level: linkListItem === null || linkListItem === void 0 ? void 0 : linkListItem.fields.nestingLevel,
        openInNewWindow: link.fields.target === 'blank'
    };
};
export var NavBarLinks = function (_a) {
    var mastheadData = _a.mastheadData, entries = _a.entries;
    var clearActiveSubmenu = useActiveSubmenuContext().clearActiveSubmenu;
    var theme = useTheme();
    return (React.createElement(StyledNavBar, { list: React.createElement("nav", { dir: "ltr" },
            React.createElement(StyledNavBarList, null, entries.filter(isNotUndefined).map(function (item, index) {
                var _a;
                if (isMastheadLink(item)) {
                    return (React.createElement("li", { key: item.fields.trackingId },
                        React.createElement(TextLink, { href: item.fields.href, color: theme.text, size: "xsmall", openInNewTab: item.fields.target === 'blank', id: item.fields.htmlId, trackingCategory: trackCat, trackingLabel: item.fields.trackingId || item.fields.title, label: item.fields.title, onHover: function () {
                                clearActiveSubmenu(null);
                            } })));
                }
                if (isMastheadLinkList(item)) {
                    return (React.createElement("li", { key: item.fields.label + index },
                        React.createElement(NavbarDropdown, { id: item.sys.id, label: item.fields.label, trackingLabels: {
                                open: mastheadData.fields.dropdownMenuLabelOpen,
                                closed: mastheadData.fields.dropdownMenuLabelClose
                            }, popoverLinks: item.fields.entries
                                ?
                                    item.fields.entries
                                        .filter(isMastheadLinkListItem)
                                        .map(buildPopoverLinkItems)
                                : [] })));
                }
                if (isMastheadGalleryMenu(item) || isMastheadCategoryMenu(item)) {
                    return (React.createElement("li", { key: ((_a = item === null || item === void 0 ? void 0 : item.fields) === null || _a === void 0 ? void 0 : _a.label) + index },
                        React.createElement(SubmenuTrigger, { id: item.sys.id, label: item.fields.label })));
                }
                return React.createElement("div", null);
            }))) }));
};
var templateObject_1, templateObject_2;
